export function getSearchParameters (key = null) {
  const parameters = decodeURIComponent(window.location.search)
    .replace(/^\?/, '')
    .split('&')
    .filter(p => p)
    .map(p => {
      const split = p.split('=')
      return { key: split[0] || '', value: split[1] || '' }
    })

  if (parameters.map(p => p.key).includes(key)) return parameters.find(p => p.key === key).value
  else if (key !== null) return null
  else return parameters
}

export function getFilenameFromContentDisposition (contentDisposition) {
  let filename = null

  // Check for filename* (UTF-8 encoded)
  const filenameStarMatch = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
  if (filenameStarMatch) {
    filename = decodeURIComponent(filenameStarMatch[1])
  } else {
    // Fallback to filename (non-UTF-8)
    const filenameMatch = contentDisposition.match(/filename\s*=\s*["']?([^;"']+)["']?/i)
    if (filenameMatch) {
      filename = filenameMatch[1]
    }
  }

  return filename
}
